import { sortBy, isEqual, findIndex } from "lodash"
import storageUtil from "./base"
function setHistoryArray(arr = []) {
  let limitLen = 15
  //第一次时，在localstorage中初始化
  if (!storageUtil.isExist('historyArray')) {
    let initHistoryArray = []
    storageUtil.addStorage('historyArray', initHistoryArray)
  }
  //已经存在localstorage时
  let res_arr, pre_arr = []
  let res = storageUtil.getStorage("historyArray")
  if (res.status === true) {
    pre_arr = res.msg
  } else {
    throw new Error(res.msg)
  }
  let arr_obj = {}
  arr.forEach((item, index) => {
    arr_obj[item] = index
  })
  //删除已经存在的记录，记录最新的index
  pre_arr = pre_arr.filter(item => {
    return arr_obj[item] === undefined || arr_obj[item] === null
  })
  res_arr = arr.concat(pre_arr)
  if (res_arr.length > limitLen) {
    res_arr = res_arr.slice(0, limitLen)
  }

  storageUtil.updateStorage('historyArray', res_arr)

}

function getHistoryArray() {
  let res = storageUtil.getStorage("historyArray")
  if (res.status === true) {
    return res.msg
  } else {
    throw new Error(res.msg)
  }
}

function deletePartialHistory(arr = []) {
  let res = getHistoryArray()
  res = res.filter(item => {
    return !arr.includes(item)
  })
  storageUtil.updateStorage('historyArray', res)
}

export default {
  setHistoryArray,
  getHistoryArray,
  deletePartialHistory
}